export const PANCHANG_CONTEXT_STRIP_HEIGHT = 34;

/**
 * Must render exactly `PANCHANG_CONTEXT_STRIP_HEIGHT` px: this skeleton reserves
 * the real strip's height so the swap cannot shift layout (rule 58).
 *
 * Tailwind's JIT needs a literal, so the value cannot be interpolated from the
 * constant without an inline style. The two are pinned to agree by
 * `PanchangContextStripSkeleton.test.tsx` — change one and that test fails.
 */
export const PANCHANG_CONTEXT_STRIP_HEIGHT_CLASS = "h-[34px]";

export function PanchangContextStripSkeleton() {
  return (
    <div
      aria-hidden="true"
      className={`mx-auto max-w-6xl px-4 flex items-center justify-between gap-4 ${PANCHANG_CONTEXT_STRIP_HEIGHT_CLASS}`}
    >
      <div className="flex min-w-0 items-center gap-2.5 overflow-hidden">
        <span className="h-2 w-16 shrink-0 rounded-lg bg-ish-border opacity-80" />
        <span className="h-2 w-24 shrink-0 rounded-lg bg-ish-border opacity-60" />
        <span className="hidden h-2 w-28 shrink-0 rounded-lg bg-ish-border opacity-50 md:block" />
      </div>
      <span className="h-2 w-14 shrink-0 rounded-lg bg-ish-border opacity-60" />
    </div>
  );
}
